export function tenantCreateErrorMessage(err, tenantId) {
  const status = err?.response?.status;
  const raw = err?.response?.data?.error || '';

  if (!err?.response) {
    return 'לא ניתן להתחבר לשרת. בדוק/י את החיבור לאינטרנט ונסה/י שוב.';
  }

  if (status === 409 || /Duplicate entry/i.test(raw)) {
    return `דייר עם ת.ז. ${tenantId || ''} כבר קיים במערכת.\nאם זהו אותו דייר, השתמש/י ב"קשר דייר קיים" במקום בהוספת דייר חדש.\nאחרת, ודא/י שהזנת ת.ז. נכונה.`;
  }

  if (/Data too long/i.test(raw)) {
    if (/firstName/i.test(raw)) return 'השם הפרטי ארוך מדי. ניתן להזין עד 20 תווים.';
    if (/lastName/i.test(raw))  return 'שם המשפחה ארוך מדי. ניתן להזין עד 20 תווים.';
    return 'אחד הערכים שהוזנו ארוך מדי. נסה/י לקצר את הטקסט.';
  }

  if (/cannot be null/i.test(raw) || /doesn't have a default value/i.test(raw)) {
    return 'חסרים פרטים חובה. ודא/י שהוזנו ת.ז., שם פרטי ושם משפחה.';
  }

  if (/Incorrect.*value/i.test(raw) || /Out of range/i.test(raw)) {
    return 'אחד הערכים שהוזנו אינו תקין (לדוגמה: תאריך לידה, % החזקה). בדוק/י את הפרטים ונסה/י שוב.';
  }

  if (status >= 500) {
    return `אירעה שגיאה בשרת בעת הוספת הדייר. נסה/י שוב בעוד רגע.\nפרטים טכניים: ${raw || 'לא ידוע'}`;
  }

  return raw || 'שגיאה בלתי צפויה בעת הוספת דייר.';
}

export function tenantLinkErrorMessage(err) {
  const status = err?.response?.status;
  const raw = err?.response?.data?.error || '';

  if (!err?.response) {
    return 'הדייר נוצר, אך לא הצלחנו לשייך אותו לדירה — אין חיבור לשרת.\nנסה/י לקשר אותו ידנית באמצעות "קשר דייר קיים".';
  }

  if (status === 409 || /Duplicate entry/i.test(raw)) {
    return 'הדייר כבר משויך לדירה זו.';
  }

  return `הדייר נוצר במערכת, אך השיוך לדירה נכשל.\nניתן לקשר אותו ידנית באמצעות "קשר דייר קיים".\nפרטים: ${raw || 'לא ידוע'}`;
}
